var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M467 181H392V31H98.787L0 129.787V406C0 447.355 33.645 481 75 481H437C478.355 481 512 447.355 512 406V226C512 201.187 491.813 181 467 181ZM424.58 211C422.915 215.695 422 220.742 422 226V361H392V211H424.58ZM90 82.213V121H51.213L90 82.213ZM30 406V151H120V61H362V406C362 422.871 367.603 438.456 377.041 451H75C50.187 451 30 430.813 30 406ZM482 406C482 430.813 461.813 451 437 451C412.187 451 392 430.813 392 406V391H452V226C452 217.729 458.729 211 467 211C475.271 211 482 217.729 482 226V406Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150 121H332V151H150V121ZM210 241H332V271H210V241ZM210 301H332V331H210V301ZM60 181H332V211H60V181ZM60 361H332V391H60V361ZM180 241H60V331H180V241ZM150 301H90V271H150V301Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.c529d995c4d63be837e98978940bbfcb.svg";
export { ForwardRef as ReactComponent };